import axios from 'axios';

let prefix = "/inventory"

const UserInventoryApi = {

	getUserInventoryList(payload) {
		return axios.get(prefix + "/user-list", { params: payload })
	},
	adjustUserInventory(payload) {
		return axios.post(prefix + "/adjust", payload)
	},
}

export default UserInventoryApi;
